import { common, modals } from '@ocean/ui'
import { ModalPropType } from '@ocean/ui/dist/components/modals/common/types'
import {
  Wrapper,
  Dialog,
  Overlay,
  Backdrop,
  Header,
  Title,
  Content,
} from './EndUserDeclarationModal.styled'

const { Decorator } = common
const { ModalTransition } = modals.common

const EndUserDeclarationModal: React.FC<ModalPropType> = props => {
  const { isOpen, title, children } = props
  return (
    <Overlay isOpen={isOpen} data-test='EndUserDeclarationModal'>
      <Backdrop data-test='EndUserDeclarationModalBackdrop' />
      <Wrapper>
        <ModalTransition isOpen={isOpen}>
          <Decorator
            dataTest='EndUserDeclarationModalDecorator'
            wrapper
            backgroundColor='white'
            textColor='black'
          >
            <Dialog data-test='EndUserDeclarationModalDialog'>
              <Header>
                <Title title={title} />
              </Header>
              <Content>{children}</Content>
            </Dialog>
          </Decorator>
        </ModalTransition>
      </Wrapper>
    </Overlay>
  )
}

export default EndUserDeclarationModal
